import { computed, toRefs } from 'vue';
import { isVue2 } from 'vue-demi';

/**
 * A composable to handle v-model compatibility between Vue 2 and Vue 3
 *   - should both contain props 'value' & 'modelValue' for vue2/3
 *   - should both contain emits 'input' & 'update:modelValue' for vue2/3
 *
 * @param {Object} props - Component props object which defined by defineProps
 * @param {Function} emits - Component emit function which defined by defineEmits
 * @returns {Object} An object containing:
 * - model: A computed property that handles v-model binding
 *   - getting value when prop changed
 *   - setting value to emit event
 */
export function useModel(props, emits) {
	const vue2 = {propName: 'value', emitName: 'input'};
	const vue3 = {propName: 'modelValue', emitName: 'update:modelValue'};

	const {propName, emitName} = isVue2 ? vue2 : vue3;
	const {[propName]: prop} = toRefs(props);

	const model = computed({
		get: () => {
			return prop.value;
		},
		set: (value) => {
			emits(emitName, value);
		},
	});

	return {
		model,
	};
}
